import { Box, BoxProps, Textarea, TextareaProps } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { ColorIcon } from "goi_common";

import { ReactNode, useRef } from "react";

interface PlaceholderProps {
  placeholder: ReactNode;
  sx: BoxProps;
}
function CustomTextarea({
  textareaProps,
  placeholderProps,
  value,
  onChange,
  removeValue,
}: {
  textareaProps: TextareaProps;
  placeholderProps: PlaceholderProps;
  value: string;
  onChange: (val: string) => void;
  removeValue: () => void;
}) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const focusTextarea = () => {
    textareaRef?.current?.focus();
  };
  return (
    <>
      <Box position="relative">
        {value.length == 0 && (
          <TextareaPlaceholder {...placeholderProps.sx} onClick={focusTextarea}>
            {placeholderProps.placeholder}
          </TextareaPlaceholder>
        )}
        <Box
          cursor="pointer"
          position="absolute"
          zIndex="2"
          bottom="6px"
          right="6px"
          onClick={removeValue}
        >
          {value.length > 0 && <ColorIcon color="#8F8F8F" name="clear" size={20} />}
        </Box>
        <Textarea
          onChange={(e) => onChange(e.target.value)}
          ref={textareaRef}
          value={value}
          {...textareaProps}
        />
      </Box>
    </>
  );
}
const TextareaPlaceholder = styled(Box)`
  position: absolute;
  z-index: 1;
`;

export default CustomTextarea;
